import React  from 'react';
//import ReactDOM from "react-dom";
import { Link } from "react-router-dom";

import { reqEndpoint } from "./Server";
import './Tiles.css';

class Tiles extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            errortext: null,
            tiles: [],
            tile: null,
            page: {skip:0, limit: 30, count: 0},
            reqInprogress : false

        };
        this.req = {doc: null, col: null};
        this.search = this.props.search;
        this.label = {
            nosearch: "geef een zoekgegeven",
            nothingfound: "zoekresultaat leeg",
            search: "voor zoekgegeven"
        };
    }

    async refreshTiles() {

        //console.log("+++ search for", this.props.search, this.state.reqInprogress)

        if (!document.getElementById("filtersearch")) return; // Nav has not yet loaded

        // --- the search word can change during the request, all letters should be handled
        if (!this.state.reqInprogress ) {

            this.setState({reqInprogress:true})
            // voorkomen repeat van refresh bij match wijziging
            this.req = this.props.match.params ;
            // voorkomen repeat van refresh bij search wijziging
            //setTimeout(()=>{
                this.search = this.props.search;
            //},1);


            // skip-limit
            const sl = {skip:0, limit: 30, count: 0};
            let tileac = {search : this.search}

            const req = {
                datareq: {
                    page: sl,
                    tileac: tileac,
                    //appuser: this.props.appuser,
                    route: this.props.match
                },
                route: "search"
            };

            const res = await reqEndpoint(req)
            //    .then(res => {

                    if (typeof res!=="object" || !res.page || (res.data && res.data.err) ) {
                        // error
                        const errtxt = (res.data && res.data.err) ? res.data.err : null;
                        //console.error("error", errtxt)
                        this.setState({error:true, errortext: errtxt});
                        return
                    }
                    this.props.setPageTurner(0); // reset any refresh request
                    this.props.setTileAc(false); // reset any refresh request
                    //console.log("+++ refreshTiles RES", res);

                    //const page = res.page;
                    //page.from = page.limit * (page.skip / page.limit) + 1;
                    //page.ntil = page.limit * ((page.skip / page.limit) + 1);
                    //if (page.ntil > page.count) page.ntil = page.count;

                    this.setState({ tiles: res.data.docs })
                    this.setState({ tile:  res.data.doc })
                    this.setState({ page:  res.page})
                    this.setState({ reqInprogress:false })

            //    })
        }
    }

    loadCards(tiles){

        const output = [];
        tiles.forEach( (item, i) => {
            //console.log("--- tile",item)
            let href = "", image ="";
            //if (!swipeable)
            let link;

            if (item.source === "account") {
                href  = "/search/org/" + item.id;
                image = "/img-hospital.svg";
                const coord = {};
                if (item.searchbody) {
                    coord.address = (item.searchbody.public ) ? `Adres: ${item.searchbody.public}`  : "";
                    coord.role    = (item.searchbody.role ) ? `Functie: ${item.searchbody.role}`  : "";
                    coord.phone = (item.searchbody.phone ) ? `Direct: ${item.searchbody.phone}`  : "";
                    coord.email = (item.searchbody.email ) ? `Email: ${item.searchbody.email}`  : "";
                    coord.href  = (item.searchbody.email ) ?  "mailto:"+item.searchbody.email : "";
                    coord.emailimg =  (item.searchbody.email ) ? "/img-mail.svg" : "";
                }

                link =
                    <div key={i}  className="media tile">

                        <Link className="tile-a" to={href}>
                            <img className="d-flex mr-3 tile-img" src={(image) ? image : ""} alt="" height="48"  width="48"/>
                        </Link>
                        <div className="tile-account">

                            <div className="media-body">
                                <Link className="tile-a" to={href}>
                                    <h5>{item.searchheader} {item.roleingroup} </h5>
                                </Link>
                                <div>
                                    <div>{ (coord.address ) ? coord.address : ""}</div>
                                    <div>{ (coord.role ) ? coord.role : ""}</div>
                                    <div>{ (coord.phone ) ? coord.phone : ""}</div>
                                    <div>{ (coord.email ) ? coord.email : ""}
                                        <a className="accountmail" href={coord.href}>
                                            <img src={coord.emailimg} alt="" height="20" width="24" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }
            else if (item.source === "group")  { 
                href  = "/search/grp/" + item.id;
                image = "/img-users.svg";
            }
            else if (item.source === "mandate")  { 
                href  = "/search/ext/" + item.id;
                image = "/img-landmark.svg";
            }
            else if (item.source === "interest")  { 
                href  = "/search/int/" + item.id;
                image = "/img-lightbulb.svg";
            }
            else {
                href  = "/search/usr/" + item.id;
                image = "/img-user.svg";
            }
            if (!link) {
                link =
                    <div key={i}  className="media tile">

                        <Link className="tile-a" to={href}>
                            <img className="d-flex mr-3 tile-img" src={(image) ? image : ""} alt="" height="48"  width="48"/>
                        </Link>
                        <Link className="tile-a" to={href}>

                            <div className="media-body">
                                <h5>{item.searchheader} {item.roleingroup} </h5>
                                <p>{ (item.searchbody && item.searchbody.public ) ? item.searchbody.public : ""}</p>
                            </div>
                        </Link>
                    </div>
            }
            output.push(link)
        });

        if (output.length>0) return <div>{output}</div> ;
        else if(!this.props.search) {
            return <div className="noutput">
                {this.label.nosearch} 
            </div>
        }
        else {
            return <div className="noutput">
                {this.label.nothingfound} {(this.props.search) ? this.label.search+" "+this.props.search : ""}
            </div>
        }
    }

    render() {
        //const tileac = {};

        if (   this.props.prevnext!==0
            || this.props.tileac
            || this.props.match.params.col!==this.req.col
            || this.props.match.params.doc!==this.req.doc ) {
            setTimeout(()=> {
                this.refreshTiles()
            },1)
        }
        else if (this.props.search!==this.search) {
            setTimeout(()=> {
                this.refreshTiles()
            },1)
        }

        if (this.state.error) {
            //console.log("*** tiles this.state.error", this.state)
            if (this.state.errortext) return (<div>{this.state.errortext}</div>)
            else return ( <div>Zjings something went wrong ...</div>)
        }
        else if (this.state.reqInprogress){
            return <div className="spinner">
                <img alt="loading..." className="navbrandlogo" src="/img-loader.gif"/>

            </div>

        }
        else {

            return (
                <div>
                    <Tile tile={this.state.tile} />
                    <ul>
                        {this.loadCards(this.state.tiles)}
                    </ul>
                </div>
            )
        }

    }

    componentDidMount(){
        this.setState({req: this.props.match.params});
        this.refreshTiles();
    }

}

class Tile extends React.Component {

    constructor(props) {
        super(props);
        this.tile = null;
    }

    render() {
        //console.log("Tile render - props", this.props);
        if (!this.props.tile ) return  <div></div>
        if (!this.props.tile.source) return  <div></div>
        let image;
        const tile = this.props.tile;

        if      (tile.source==="account") {
            image = "/img-hospital.svg";

            return <div className="media tiletop">
                <div>
                    <img className= "d-flex mr-3 topimg" src={image} alt="" height="32" width="32"/>
                </div>
                <div className={"media-body "}>
                    <div className="tile-a" >
                        <h5>
                            {tile.searchheader} 
                        </h5>
                        <p>{tile.searchbody.public || ""}</p>
                    </div>
                </div>
            </div>
        }
        else if (tile.source==="group") {
            image = "/img-users.svg";

            return <div className="media tiletop">
                <div>
                    <img className= "d-flex mr-3 topimg" src={image} alt="" height="32" width="32"/>
                </div>
                <div className={"media-body "}>
                    <div className="tile-a" >
                        <h5>
                            {tile.searchheader} 
                        </h5>
                    </div>
                </div>

            </div>
        }
        else if (tile.source==="mandate") {
            image = "/img-landmark.svg";

            return <div className="media tiletop">
                <div>
                    <img className= "d-flex mr-3 topimg" src={image} alt="" height="32" width="32"/>
                </div>
                <div className={"media-body "}>
                    <div className="tile-a" >
                        <h5>
                            {tile.searchheader} 
                        </h5>
                    </div>
                </div>

            </div>
        }
        else if (tile.source==="interest") {
            image = "/img-lightbulb.svg";

            return <div className="media tiletop">
                <div>
                    <img className= "d-flex mr-3 topimg" src={image} alt="" height="32" width="32"/>
                </div>
                <div className={"media-body "}>
                    <div className="tile-a" >
                        <h5>
                            {tile.searchheader} 
                        </h5>
                    </div>
                </div>

            </div>
        }
        else if (tile.source==="contact") {
            image = "/img-user.svg";
            let imagewh = "32"
            if (tile.photo) {
                image = "data:image/png;base64,"+tile.photo;
                imagewh = "64"
            }
            let privatedata = "";
            if (tile.searchbody.private) {
                const coord = {};
                coord.dateofbirth = (tile.searchbody.private.dateofbirth ) ? `Geboortedatum: ${tile.searchbody.private.dateofbirth}`  : "";
                coord.address = (tile.searchbody.private.address ) ? `Adres: ${tile.searchbody.private.address}`  : "";
                coord.phone = (tile.searchbody.private.phone ) ? `Telefoon: ${tile.searchbody.private.phone}`  : "";
                coord.email = (tile.searchbody.private.email ) ? `Email: ${tile.searchbody.private.email}`  : "";
                coord.href  = (tile.searchbody.private.email ) ?  "mailto:"+tile.searchbody.private.email : "";
                coord.emailimg =  (tile.searchbody.private.email ) ? "/img-mail.svg" : "";

                return <div className="media tiletop">
                            <div>
                                <img className="d-flex mr-3 topimg topimgphoto" src={image} alt="" height={imagewh} width={imagewh}/>
                            </div>
                            <div className={"media-body "}>
                                <div className="tile-a tile-account" >
                                    <h5>
                                        {tile.searchheader}
                                    </h5>
                                    <div>
                                        <div>{ (coord.dateofbirth ) ? coord.dateofbirth : ""}</div>
                                        <div>{ (coord.address ) ? coord.address : ""}</div>
                                        <div>{ (coord.phone ) ? coord.phone : ""}</div>
                                        <div>{ (coord.email ) ? coord.email : ""}

                                            <a className="accountmail" href={coord.href}>
                                                <img src={coord.emailimg} alt="" height="20" width="24" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>


            }
            else {
                return <div className="media tiletop">
                    <div>
                        <img className="d-flex mr-3 topimg topimgphoto" src={image} alt="" height={imagewh} width={imagewh}/>
                    </div>
                    <div className={"media-body "}>
                        <div className="tile-a" >
                            <h5>
                                {tile.searchheader}
                            </h5>
                            <p>{privatedata}</p>
                        </div>
                    </div>

                </div>
            }
        }

    }
}


export default Tiles;




// WEBPACK FOOTER //
// ./src/Tiles.js